import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const ssoRedirectUri = (provider) => `${window.location.origin}/auth/sso/${provider}`;

export async function startSso(provider) {
  const r = await api.post(`/auth/sso/${provider}/start`, { redirect_uri: ssoRedirectUri(provider) });
  window.location.href = r.data.url;
}

export default function SsoCallback() {
  const { provider } = useParams();
  const [params] = useSearchParams();
  const { applySession } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState(params.get("error_description") || params.get("error"));
  useEffect(() => {
    if (error) return;
    api.post(`/auth/sso/${provider}/exchange`, { code: params.get("code"), state: params.get("state"), redirect_uri: ssoRedirectUri(provider) })
      .then((r) => { applySession(r.data); navigate("/app", { replace: true }); })
      .catch((e) => setError(errMsg(e)));
    // eslint-disable-next-line
  }, []);
  return (
    <div className="min-h-screen grid place-items-center p-6">
      <div className="surface p-8 max-w-md text-center" data-testid="sso-callback">
        {error ? <><div className="font-display font-semibold text-rose-600">Sign-in failed</div><p className="text-sm text-muted-foreground mt-2" data-testid="sso-error">{error}</p><button className="text-sm text-primary underline mt-4" onClick={() => navigate("/login")}>Back to login</button></> : <div className="text-muted-foreground">Completing {provider} sign-in…</div>}
      </div>
    </div>
  );
}
